<template>
    <!-- 兑换活动管理-商品信息组件 -->
    <a-card :title="title" :bordered="bordered">
        <slot></slot>
        <!-- 线上票 -->
        <div v-if="goodsType == 1 || goodsType == 2">
            <a-row class="mb16">
                <a-col :span="8">商品分类：线上票</a-col>
                <a-col :span="8">展示名称：{{dataDetail.showName}}</a-col>
                <a-col :span="8">内部标识：{{dataDetail.name}}</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col :span="8">使用次数：{{dataDetail.useNum == -1 ? '期限卡，不限次' : ('限次卡，' + dataDetail.useNum + '次')}}</a-col>
                <a-col :span="8">适用时段：{{suitTime[dataDetail.suitTime]}}</a-col>
                <a-col :span="8">使用人数：{{dataDetail.adultNum + '大' + dataDetail.babyNum}}小</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col :span="8">有效期：{{dataDetail.validTimeSetMode == 2 ? (dataDetail.validTime) : '自购卡日期起，有效期'+ dataDetail.validTime +'天'}}</a-col>
                <a-col :span="8">预约方式：{{['无需预约','在线预约'][Number(dataDetail.isNeedReserve)]}}</a-col>
                <a-col :span="8">售卖价格：{{Number(dataDetail.sellShowPrice).toFixed(2)}}</a-col>
            </a-row>
            <a-row v-if="shops">
                <a-col :span="24">适用门店：{{dataDetail.scope == 1 ? '全国门店通用' : (shopName.length > 0 ? shopName.join('、') : '-')}}</a-col>
            </a-row>
        </div>
        <!-- 线下票 -->
        <!-- <div v-if="goodsType == 2">
            <a-row class="mb16">
                <a-col :span="8">商品分类：线下票</a-col>
                <a-col :span="8">展示名称：{{dataDetail.showName}}</a-col>
                <a-col :span="8">内部标识：{{dataDetail.name}}</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col :span="8">使用次数：{{dataDetail.calculateType == 0 ? '不限次卡' : ('限次卡，' + dataDetail.useNum + '次')}}</a-col>
                <a-col :span="8">适用时段：-</a-col>
                <a-col :span="8">使用人数：{{dataDetail.adultNum + '大' + dataDetail.babyNum}}小</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col :span="8">有效期：{{dataDetail.dateType == 2 ? (dataDetail.validStartTime + ' ~ ' + dataDetail.validEndTime) : ('购买后'+dataDetail.validSellHour+'小时开始生效，有效期'+dataDetail.validHour+'小时')}}</a-col>
                <a-col :span="8">预约方式：-</a-col>
                <a-col :span="8">售卖价格：{{Number(dataDetail.sellPrice).toFixed(2)}}</a-col>
            </a-row>
            <a-row>
                <a-col :span="24">适用门店：{{shopName.length > 0 ? shopName.join('、') : '-'}}</a-col>
            </a-row>
        </div> -->
        <!-- 优惠券 -->
        <div v-if="goodsType == 3">
            <a-row class="mb16">
                <a-col :span="8">商品分类：优惠券</a-col>
                <a-col :span="8">展示名称：{{dataDetail.name}}</a-col>
                <a-col :span="8">内部标识：-</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col :span="8">适用类型：{{['','门票','餐饮','零售','课程'][dataDetail.suitType]}}</a-col>
                <a-col :span="8">优惠类型：{{['','满减券','折扣券'][dataDetail.couponType]}}</a-col>
                <a-col :span="8" v-if="dataDetail.couponType == 1">优惠规则：{{dataDetail.threshold == 1 ? ('有门槛，满' + dataDetail.fullAmount) : ('无门槛') + '减' + dataDetail.reduceAmount}}</a-col>
                <a-col :span="8" v-if="dataDetail.couponType == 2">优惠规则：{{dataDetail.threshold == 1 ? ('有门槛，满' + dataDetail.fullAmount) : ('无门槛') + '打' + (dataDetail.discountRate * 10).toFixed(1) + '折'}}</a-col>
            </a-row>
            <a-row>
                <a-col :span="8">有效期：{{dataDetail.dateType == 1 ? (dataDetail.validStartTime + ' ~ ' + dataDetail.validEndTime) : ('自领取日期起，有效期'+ dataDetail.validDates+'天')}}</a-col>
                <a-col :span="16" v-if="dataDetail.shopRange == 2">适用门店：{{shopName.length > 0 ? shopName.join('、') : '-'}}</a-col>
                <a-col :span="16" v-if="dataDetail.shopRange == 1">适用门店：全部门店适用</a-col>
            </a-row>
        </div>
        <!-- 储值 -->
        <div v-if="goodsType == 4">
            <a-row class="mb16">
                <a-col :span="8">商品分类：储值</a-col>
                <a-col :span="8">展示名称：{{dataDetail.name}}</a-col>
                <a-col :span="8">内部标识：-</a-col>
            </a-row>
            <a-row>
                <a-col :span="8">储值金额：{{Number(dataDetail.amount).toFixed(2)}}</a-col>
            </a-row>
        </div>
    </a-card>
</template>

<script type="text/javascript">
    export default {
        name: "exchangeGoods",
        components: {},
        props: {
            bordered: {
                type: Boolean,
                default: true,
            },
            shops: {
                type: Boolean,
                default: true,
            },
            title: {
                type: String,
                default: "",
            },
            goodsType: {
                type: Number,
                default: -1,
            },
            goodsId: {
                type: String,
                default: ""
            },
            goodsDetail: {
                type: Object,
                default: () => {return {}}
            }
        },
        data() {
            return {
                dataDetail: {},
                shopName: [],
                suitTime: {
				    Currency: "平日周末通用",
                    Weekend: "周末可用",
                    WorkDay: "平日可用",
                }
            };
        },
        methods: {
            getTicketDetail(shopList) {
                this.$api.totalPlatform.ticketDetail({
                    params: {ticketTemplateId: this.goodsId}
                })
                .then(res => {
                    if (res.validTimeSetMode == 2) {
                        res.validTime = res.validTimeSetParam.split("~")[0].substring(0, 10) + "~" + res.validTimeSetParam.split("~")[1].substring(0, 10)
                    } else {
                        res.validTime = res.validTimeSetParam || 0;
                    }
                    this.dataDetail = res;
                    this.shopName = [];
                    res.suitShopReserveStockConfigs.forEach(item => {
                        shopList.forEach(shop => {
                            if(item.shopId == shop.id) {
                                this.shopName.push(shop.name);
                            }
                        })
                    })
                })
            },
            // 查看详情--获取优惠券详情
            getCouponsDetail() {
                this.$api.changeCode.newCouponDetail({
                    params: {id: this.goodsId}
                }).then(res => {
                    this.dataDetail = res;
                    this.shopName = [];
                    res.shopSuitList && res.shopSuitList.forEach(item => {
                        shopList.forEach(shop => {
                            if(item == shop.id) {
                                this.shopName.push(shop.name);
                            }
                        })
                    })
                })
            },
            // 获取储值配置
            getStoredConfigDetail() {
                this.$api.totalPlatform.getStoredValueCard().then(res => {
                    this.dataDetail = res.length > 0 && res.filter(item => {
                        return item.id == this.goodsId;
                    })[0]
                })
            },
            // 门店列表
            getShopList(val) {
                this.$api.totalPlatform.selectList().then(res => {
                    if(val == 1) {
                        this.getTicketDetail(res);
                    }else if(val == 2) {
                        this.getTicketDetail(res);
                    }else if(val == 3) {
                        this.getCouponsDetail(res);
                    }
                });
            },
        },
        beforeCreate() {},
        created() {},
        mounted() {
            if(this.goodsType == 4) {
                this.getStoredConfigDetail()
            }else if(this.goodsType != undefined) {
                this.getShopList(this.goodsType);
            }
        },
        watch: {
            goodsType(val) {
                if(val == 4) {
                    this.getStoredConfigDetail()
                }else {
                    this.getShopList(val);
                }
            }
        }
    };
</script>
<style lang="scss">
</style>